import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
import {withColor} from "@web-libs/ui/svgs/fill/with-color";
const _ArrowIcon: SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 16}
        height={props.height ?? 16}
        viewBox="0 0 24 24"
    >
        <path fill={props.fill} d="M18 12a2 2 0 0 0-.59-1.4l-4.29-4.3a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.42L15 11H5a1 1 0 0 0 0 2h10l-3.29 3.29a1 1 0 0 0 1.41 1.42l4.29-4.3A2 2 0 0 0 18 12Z" />
    </svg>
)

const ArrowIcon = withColor(_ArrowIcon)
export {_ArrowIcon}
export default ArrowIcon
